import React from 'react';
import { Message, Card, Loader } from 'semantic-ui-react';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import axios from 'axios';
import _ from 'lodash';

// const LOGIN_API = 'https://npktm6eo6a.execute-api.eu-west-1.amazonaws.com/production/user/login/url';
//
// // const postLogin = event => {
// //   event.preventDefault();
// //
// //   const iat = moment().unix();
// //   const exp = moment().add(2, 'days').unix();
// //
// //   const options = {
// //     email: 'laurie+corq@dyzio.co',
// //     iat,
// //     exp,
// //   };
// //
// //   console.log(options);
// //
// //   const token = jwt.sign(options, 'shhhhh');
// //
// //   const ax = axios.create({
// //     timeout: 6000,
// //     headers: {
// //       Authorization: `Bearer ${token}`,
// //     },
// //   });
// //
// //   console.log(token);
// //   return ax.get(LOGIN_API).then(r => {
// //     const { loginURL } = r.data.data;
// //     console.log(loginURL);
// //     // return null;
// //     const campaignUrl = `${loginURL}&campaign=ad9e7304-7ed5-4393-82eb-84538290f9a5`;
// //     console.log(campaignUrl);
// //     window.location = campaignUrl;
// //   });
// // };


class CorqLogin extends React.Component {
  state = {
    loginStem: 'eep',
    loading: true,
  };
  componentDidMount = async () => {
    const iat = moment().unix();
    const exp = moment().add(2, 'days').unix();

    const options = {
      email: 'laurie+corq@dyzio.co',
      iat,
      exp,
    };

    console.log(options);

    const token = jwt.sign(options, 'shhhhh');

    const ax = axios.create({
      timeout: 6000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log(token);

    return ax.get('https://npktm6eo6a.execute-api.eu-west-1.amazonaws.com/production/campaigns').then(r => {
      const campaigns = r.data.data;
      console.log(campaigns);
      this.setState({
        campaigns,
        loading: false,
        // loginStem,
      });
    });
  }


  render() {
    const { campaigns, loading } = this.state;
    return (
      <div style={{ width: 600 }}>
        <Message>CORQ TEST SITE</Message>

        <h1>Campaigns</h1>

        {
          loading &&
          <div style={{ paddingTop: 50 }}>
            <Loader
              active
              content="Loading campaigns..."
              inline="centered"
              size="massive"
            />
          </div>
        }
        {
          campaigns &&
          _.map(campaigns, c => (
            <Card
              onClick={() => {
                const campaignUrl = c.loginURL;
                window.open(campaignUrl);
              }}
              fluid
              header={c.attributes.name}
              meta="CORQ"
              extra={`Created ${moment(c.attributes.createdDate).format('lll')}`}
            />
          ))
        }


      </div>);
  }
}

export default CorqLogin;



// WEBPACK FOOTER //
// ./src/components/corq-login/index.js